/** 电费方案 /metering/fee/electricity-plan（electricityPlan.vue） */
export default {
  electricityPlanPage: {
    sectionTitle: '电费方案',
    btnAddPlan: '新增方案',
    emptyTable: '暂无电表方案数据',
    emptyNoPermission: '暂无查看权限',
    colPlanId: '方案ID',
    colPlanName: '方案名称',
    colPeak: '尖电价(元/度)',
    colTop: '峰电价(元/度)',
    colFlat: '平电价(元/度)',
    colValley: '谷电价(元/度)',
    colUpdated: '更新时间',
    colAction: '操作',
    btnAdjustPrice: '调价',
    btnLog: '日志',
    btnBatchBind: '批量绑定',
    modalTitleEdit: '调整电价',
    modalTitleAdd: '新增方案',
    formPlanName: '方案名称',
    phPlanName: '请输入方案名称',
    labelPeak: '尖电价',
    labelTop: '峰电价',
    labelFlat: '平电价',
    labelValley: '谷电价',
    unitPerKwh: '元/度',
    warnEditAffectsMeters: '注：修改方案会同时更改相应电表计费金额',
    labelEnableRule: '启动规则',
    labelActivationDate: '启用时间',
    phActivationDate: '请选择启用时间',
    labelPhoneBound: '绑定手机',
    labelVerifyCode: '验证码',
    phVerifyCode: '请输入验证码',
    sendCode: '发送验证码',
    resendIn: '{n} 秒后可重发',
    btnCancel: '取消',
    btnConfirm: '确定',
    drawerBatchBindTitle: '批量绑定电表',
    tabDedicated: '专用电表',
    tabShare: '公摊电表',
    tabAir: '空调表',
    phSearchMeter: '搜索电表名称',
    selectAll: '全选',
    tagBound: '已绑定',
    emptyTreeNoMatch: '没有找到匹配的电表',
    emptyTreeNoData: '暂无电表数据',
    selectedMeters: '已选择 {count} 个电表',
    btnConfirmBind: '确认绑定',
    logTitle: '调价日志',
    emptyLog: '暂无调价记录',
    logColPlanName: '方案名称',
    logColPeak: '尖电价(元/度)',
    logColTop: '峰电价(元/度)',
    logColFlat: '平电价(元/度)',
    logColValley: '谷电价(元/度)',
    logColEnableRule: '启用规则',
    logColEnableStatus: '启用状态',
    logColScheduledTime: '预约启用时间',
    logColExecutedTime: '实际启用时间',
    logColCreated: '创建时间',
    logColOperator: '操作账号',
    logColAction: '操作',
    btnWithdraw: '撤回',
    enableModeImmediate: '立即启动',
    enableModeScheduled: '定时启动',
    enableStatusActive: '已启用',
    enableStatusPending: '待启用',
    enableStatusDiscarded: '废弃',
    tabGroupTenant: '租户',
    tabGroupShare: '公摊',
    tabGroupAir: '空调',
    groupUngrouped: '未分组',
    groupAirDefault: '空调表',
    msgLoadFail: '获取数据失败',
    msgNoAdd: '暂无新增权限',
    msgNoOperate: '暂无操作权限',
    msgSmsSent: '验证码已发送',
    msgSmsFail: '发送验证码失败',
    msgNameRequired: '请输入方案名称',
    msgPriceZero: '电价不可为0',
    msgPriceIncomplete: '请填写完整的电价信息',
    msgEnableRule: '请选择启动规则',
    msgActivationDate: '请选择启用时间',
    msgVerifyCode: '请输入验证码',
    titleTip: '提示',
    btnOk: '确定',
    confirmModifyPlan: '确认修改方案？',
    confirmAddPlan: '确认新增方案？',
    msgOpOk: '操作成功',
    msgOpFail: '操作失败',
    confirmBindMeters: '确认绑定 {count} 个电表到该方案？',
    msgBindOk: '绑定成功',
    msgBindFail: '绑定失败',
    msgSelectMeters: '请选择要绑定的电表',
    msgSelectNewMeters: '请选择新的电表进行绑定',
    msgMeterListFail: '获取电表列表失败',
    msgLogFail: '获取日志失败',
    confirmWithdraw: '确认撤回？',
    msgWithdrawOk: '撤回成功',
    msgWithdrawFail: '撤回失败'
  }
}
